<template>
  <a-focus-trap
    :is-enabled="isExpanded"
    :initial-focus="`#nav-search-toggle-${uuid}`"
  >
    <div class="nav-search" @keydown.esc="collapseWithOverlay">
      <slot></slot>
    </div>
  </a-focus-trap>
</template>

<script>
import { HeaderEventBus, OverlayEventBus, DialogEventBus } from '@js/eventBus';
import { mapGetters } from 'vuex';

export default {
  provide() {
    const context = {};

    Object.defineProperty(context, 'isExpanded', {
      enumerable: true,
      get: () => this.isExpanded,
    });

    Object.defineProperty(context, 'uuid', {
      enumerable: true,
      get: () => this.uuid,
    });

    return {
      context: context,
      toggle: this.toggle,
    };
  },
  data() {
    return {
      isExpanded: false,
      uuid: this.$uuid.v1(),
      overwriteOverlayOnce: false,
    };
  },
  watch: {
    isExpanded(value) {
      this.$store.dispatch('overlay/set', {
        isVisible: this.overwriteOverlayOnce ? true : value,
        triggerName: this.$options._componentTag,
      });

      this.overwriteOverlayOnce = false;

      if (!value) return;
      HeaderEventBus.$emit('search-opened');
    },
  },
  mounted() {
    HeaderEventBus.$on('dropdown-opened', this.collapse);
    HeaderEventBus.$on('burger-opened', this.collapse);
    HeaderEventBus.$on('dossier-opened', this.collapse);
    DialogEventBus.$on('dialog-opened', this.collapse);
    OverlayEventBus.$on('overlay-clicked', this.collapseWithOverlay);
  },
  beforeDestroy() {
    HeaderEventBus.$off('dropdown-opened', this.collapse);
    HeaderEventBus.$off('burger-opened', this.collapse);
    HeaderEventBus.$off('dossier-opened', this.collapse);
    DialogEventBus.$off('dialog-opened', this.collapse);
    OverlayEventBus.$off('overlay-clicked', this.collapseWithOverlay);
  },
  methods: {
    collapseWithOverlay() {
      this.isExpanded = false;
    },
    collapse() {
      this.isExpanded = false;
      this.overwriteOverlayOnce = true;
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
